{
  "DataTable_AreYouSure": "Are you sure you want to delete the following?\n\n**{}**",
  "DataTable_RowsPerPage": "Rows per page",
  "DataTable_Of": "{}-{} of {}",
  "DataTable_Next": "Next page",
  "DataTable_Previous": "Previous page",
  "NAME": "LanguageDataTable"
}